import {useEffect} from 'react';
import {useStore} from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import DefaultTemplate from '@templates/DefaultTemplate';
import {Wrapper} from '@components/GridCards/Common.styled';
import Reward from '@components/Reward';

export const RewardPage = () => {
  const { settings } = useStore();
  
  const i18n = useI18n();


  useEffect(() => {
    
    window.scrollTo(0,0)
  },[])


  async function getData(id) {

  }

  return (
    <DefaultTemplate>
      <Wrapper>
        <Reward />
      </Wrapper>
    </DefaultTemplate>
  );
};

export default RewardPage;